import { render } from "./NewPhotoUploaderComponent.vue?vue&type=template&id=14e48623&scoped=true&ts=true"
import script from "./NewPhotoUploaderComponent.vue?vue&type=script&lang=ts"
export * from "./NewPhotoUploaderComponent.vue?vue&type=script&lang=ts"

import "./NewPhotoUploaderComponent.vue?vue&type=style&index=0&id=14e48623&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14e48623"]])

export default __exports__